<template>
  <div :id="key + '_lineChart'" :style="{ width, height }" />
</template>

<script>
import * as echarts from "echarts";
import { EchartsJfTheme } from "@/assets/scripts/echarts-themes";

echarts.registerTheme("echarts-jf-theme", EchartsJfTheme);

export default {
  name: "LineChart",
  props: {
    height: {
      type: String,
      default: "300px"
    },
    width: {
      type: String,
      default: "100%"
    },
    xAxisLabels: {
      type: Array,
      default: () => []
    },
    xAxisType: {
      type: String,
      default: "category"
    },
    dataSeries: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      key: Math.floor(Math.random() * 10000)
    };
  },
  mounted() {
    let lineChart = echarts.init(
      document.getElementById(this.key + "_lineChart"),
      "echarts-jf-theme"
    );

    // Draw the chart
    lineChart.setOption({
      tooltip: {
        trigger: "axis",
        formatter: (params) => {
          // Access the first data point item in the hovered axis
          const item = params[0];

          let formattedLabel = item.value[0];
          if (this.xAxisType === "time") {
            // 1. Format the Date (e.g., "Jul 18, 2026 00:00")
            const date = new Date(item.value[0]); // Assumes [time, value] data array structure
            const options = { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false };
            formattedLabel = date.toLocaleDateString('en-US', options).replace(',', '');
          }

          // 2. Format Category/Data Name to All Caps
          let upperSeriesName = item.seriesName.length == 3 ? item.seriesName.toUpperCase() : item.seriesName.slice(0, 1).toUpperCase() + item.seriesName.slice(1);
          if (upperSeriesName == "External_conversions") {
            upperSeriesName = "Conversions";
          }

          // 3. Format Numeric Value to 2 Decimals Max
          const rawValue = item.value[1];
          let formattedValue = rawValue == "-" ? "0" : (rawValue.toString().includes(".") ? Number(rawValue).toFixed(2) : this.numberFormatter(rawValue));

          if (["Spend", "CPM", "CPC"].includes(upperSeriesName)) {
            formattedValue = "$" + formattedValue;
          }
          else if (["CTR"].includes(upperSeriesName)) {
            formattedValue = formattedValue + "%";
          }

              // Build and return the HTML tooltip card string
          return `
        <div style="font-size: 14px; color: #666; font-weight: 400; line-height: 1;">${formattedLabel}</div>
        <div style="margin-top: 10px; display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center;">
            ${item.marker}
            <span style="margin-left: 5px; color: #666; font-weight: 400;">${upperSeriesName}</span>
          </div>
          <span style="margin-left: 20px; font-weight: 700; color: #333;">${formattedValue}</span>
        </div>
      `;
        }
      },
      grid: {
        left: 5,
        right: 0,
        bottom: 1,
        top: 5,
        containLabel: true
      },
      xAxis: {
        data: this.xAxisLabels.map((label, i) => {
          return {
            value: label,
            textStyle:
              i === 0
                ? { align: "left" }
                : i === this.xAxisLabels.length - 1
                ? { align: "right" }
                : {}
          };
        }),
        type: this.xAxisType,
        boundaryGap: false,
        axisLabel: {
          align: "left",
          formatter: {
            year: '{yyyy}',
            month: '{MMM}',
            day: '{MMM} {d}',
            hour: '{HH}:{mm}',
            minute: '{HH}:{mm}',
            second: '{HH}:{mm}:{ss}'
          }
        }
      },
      yAxis: {
        position: "right",
        overlap: "truncate",
        scale: true
      },
      series: this.dataSeries.map(data => {
        return { ...data, type: "line" };
      })
    });

    /*document.getElementById(this.key + "_lineChart").addEventListener("resize", function() {
      lineChart.resize();
    });*/
    const lineChartElement = document.getElementById(this.key + "_lineChart");
    {
      let prevWidth;
      new ResizeObserver(changes => {
        for (const change of changes) {
          if (change.contentRect.width === prevWidth) return;
          prevWidth = change.contentRect.width;
          lineChart.resize();
        }
      }).observe(lineChartElement);
    }
  },
  methods: {}
};
</script>

<style scoped lang="scss"></style>
